import { OPT_IN_FEATURE_NODES, DEFAULT_NODE_LIST_EDIT_MODE, DEFAULT_NODE_LIST_READ_MODE } from '../constant.mjs';

function getNodeListByFeatures({
  features,
  editable
}) {
  return features.reduce(
    (prev, cur) => {
      return [...prev, ...OPT_IN_FEATURE_NODES[cur]];
    },
    editable ? [...DEFAULT_NODE_LIST_EDIT_MODE] : [...DEFAULT_NODE_LIST_READ_MODE]
  );
}

export { getNodeListByFeatures };
//# sourceMappingURL=node.mjs.map
